<template>
    <div>
        <div class="title-wrapper" :style="getWrapperStyle">
            <span class="titleText">{{config.text}}</span>
        </div>
    </div>

</template>


<script>
    export default {
        name: 'title-block',
        props: {
            config: {},
            componentData: {},


        },
        data() {
            return {}
        },
        computed: {

            getWrapperStyle() {
                var CSS_STRING = "text-transform: uppercase !important;"
                CSS_STRING += "background:" + this.config.wrapper.background + ";"
                CSS_STRING += "color: " + this.config.wrapper.color + ";"
                CSS_STRING += "font-weight: " + this.config.wrapper.fontWeight + ";"
                CSS_STRING += "padding:" + this.config.wrapper.padding + ";"
                CSS_STRING += "margin:" + this.config.wrapper.margin+" 0   "+ this.config.wrapper.margin+";"
                return CSS_STRING
            },

        },
        methods: {},
        created() {


        }
    }
</script>
<style lang="scss" scoped>
    .title-wrapper {
        font-size:30px;
        text-align:center;
        background: transparent;
    }

</style>